import BaseInfoItem from './BaseInfoItem';
import LocalizationManager from '../../i18n/LocalizationManager';

export default class DisplayRtp extends BaseInfoItem {
  constructor(container, display_rtp) {
    super(container);
    this.view.innerText = `RTP: ${display_rtp}`
  }
}
